import React from 'react';
import { InputGroupWithButton } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useMetadataInput } from '../../hooks/useMetadataInput';
import styles from './metadataInput.module.scss';

export const MetadataInput = ({ onAdd, options, msgIdSuffix }) => {
    const { config, isDisabled, onClick } = useMetadataInput(onAdd, options, msgIdSuffix);
    return (
        <InputGroupWithButton
            className={styles['group']}
            config={config}
            delimiterClassName={styles['delimiter']}
            buttonProps={{
                onClick,
                disabled: isDisabled,
                className: styles['submit-button'],
                children: (
                    <FormattedMessage
                        id="externalMetadata.editor.input.group.button.submit.text"
                        defaultMessage="Submit"
                    />
                ),
            }}
        />
    );
};
